import ApiService from '@/services/core/api.service'

const AgentService = {
  async get (query) {
    return ApiService.get(`supervisor/agents?${query}`)
  },

  async post (payload) {
    return ApiService.post('supervisor/agents', payload)
  },

  async put (payload) {
    return ApiService.put(`supervisor/agents/${payload.id}`, payload)
  }
}

export default AgentService
